export type VtoPageType = typeof SINGLE_PRODUCT_PAGE | typeof GRID_PAGE;
export const SINGLE_PRODUCT_PAGE = "single product page";
export const GRID_PAGE = "grid page";

export const VTO_CONFIGURATION_UNDEFINED = "VTO_CONFIGURATION_UNDEFINED";

export const beautyFamilyCode = "V10";
